/** Registers the ReferenceRect parser. `index.r3f.ts` registers the painter (ADR-0001). */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseReferenceRect } from './parser';
const referenceRectRegistration = {
    typeName: 'ReferenceRect',
    parser: parseReferenceRect,
};
nodeRegistry.register(referenceRectRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map